export const questions = [
  {
    questionText: 'What class interests you the most?',
    answerOptions: [
      {
        optionText: 'Charms', gryffindor: 2, slytherin: 1, ravenclaw: 2, hufflepuff: 1,
      },
      {
        optionText: 'Potions', gryffindor: 1, slytherin: 1, ravenclaw: 3, hufflepuff: 1,
      },
      {
        optionText: 'Transfiguration', gryffindor: 1, slytherin: 2, ravenclaw: 1, hufflepuff: 3,
      },
      {
        optionText: 'Defense Against the Dark Arts', gryffindor: 3, slytherin: 3, ravenclaw: 1, hufflepuff: 0,
      },
    ],
  },
  {
    questionText: 'What would you do if you saw a classmate being bullied?',
    answerOptions: [
      {
        optionText: 'Tell a teacher', gryffindor: 1, slytherin: 3, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Tell the bully to stop', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 2,
      },
      {
        optionText: 'Tell the classmate to ignore it', gryffindor: 3, slytherin: 0, ravenclaw: 2, hufflepuff: 2,
      },
      {
        optionText: 'Join in', gryffindor: 0, slytherin: 2, ravenclaw: 1, hufflepuff: 3,
      },
    ],
  },
  {
    questionText: 'If you were an animal, what would you rather be?',
    answerOptions: [
      {
        optionText: 'A lion', gryffindor: 3, slytherin: 1, ravenclaw: 2, hufflepuff: 3,
      },
      {
        optionText: 'A snake', gryffindor: 2, slytherin: 4, ravenclaw: 0, hufflepuff: 1,
      },
      {
        optionText: 'An eagle', gryffindor: 0, slytherin: 1, ravenclaw: 3, hufflepuff: 1,
      },
      {
        optionText: 'A badger', gryffindor: 1, slytherin: 0, ravenclaw: 1, hufflepuff: 2,
      },
    ],
  },
  {
    questionText: 'If you could have any superpower, what would it be?',
    answerOptions: [
      {
        optionText: 'Invisibility', gryffindor: 1, slytherin: 1, ravenclaw: 3, hufflepuff: 1,
      },
      {
        optionText: 'Flying', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 3,
      },
      {
        optionText: 'Super strength', gryffindor: 3, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Mind reading', gryffindor: 1, slytherin: 3, ravenclaw: 1, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'If you could take a luck potion to win a quidditch match, would you?',
    answerOptions: [
      {
        optionText: 'Absolutely', gryffindor: 0, slytherin: 2, ravenclaw: 0, hufflepuff: 1,
      },
      {
        optionText: 'Maybe', gryffindor: 1, slytherin: 2, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'No', gryffindor: 2, slytherin: 1, ravenclaw: 1, hufflepuff: 2,
      },
      {
        optionText: 'I don\'t play quidditch', gryffindor: 1, slytherin: 0, ravenclaw: 1, hufflepuff: 2,
      },
    ],
  },
  {
    questionText: 'What would you rather do?',
    answerOptions: [
      {
        optionText: 'Go to a party', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Stay home and read', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Go on an adventure', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Help someone', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'Among the following, Who is your favorite professor?',
    answerOptions: [
      {
        optionText: 'Severus Snape', gryffindor: 1, slytherin: 3, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Minerva McGonagall', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 3,
      },
      {
        optionText: 'Remus Lupin', gryffindor: 3, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Alastor \'Mad-Eye\' Moody', gryffindor: 1, slytherin: 1, ravenclaw: 3, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'In a 1 on 1 duel, what is your favorite spell?',
    answerOptions: [
      {
        optionText: 'Expelliarmus!', gryffindor: 2, slytherin: 1, ravenclaw: 2, hufflepuff: 2,
      },
      {
        optionText: 'Protego!', gryffindor: 1, slytherin: 1, ravenclaw: 2, hufflepuff: 3,
      },
      {
        optionText: 'Stupefy!', gryffindor: 2, slytherin: 1, ravenclaw: 2, hufflepuff: 1,
      },
      {
        optionText: 'Crucio!', gryffindor: 1, slytherin: 3, ravenclaw: 0, hufflepuff: 0,
      },
    ],
  },
  {
    questionText: 'How would you like to see yourself in the magic Mirror of Erised?',
    answerOptions: [
      {
        optionText: 'Holding a wand', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'Rich beyond measure', gryffindor: 0, slytherin: 3, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'With a family', gryffindor: 4, slytherin: 1, ravenclaw: 1, hufflepuff: 3,
      },
      {
        optionText: 'With a pet', gryffindor: 1, slytherin: 2, ravenclaw: 2, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'If you could own a magic creature, which would you pick?',
    answerOptions: [
      {
        optionText: 'Unicorn', gryffindor: 1, slytherin: 0, ravenclaw: 1, hufflepuff: 2,
      },
      {
        optionText: 'Phoenix', gryffindor: 3, slytherin: 1, ravenclaw: 3, hufflepuff: 2,
      },
      {
        optionText: 'Dragon', gryffindor: 1, slytherin: 2, ravenclaw: 1, hufflepuff: 0,
      },
      {
        optionText: 'Chimera', gryffindor: 1, slytherin: 3, ravenclaw: 0, hufflepuff: 2,
      },
    ],
  },
  {
    questionText: 'What material would you choose for your wand?',
    answerOptions: [
      {
        optionText: 'Unicorn hair', gryffindor: 1, slytherin: 0, ravenclaw: 3, hufflepuff: 2,
      },
      {
        optionText: 'Phoenix feather', gryffindor: 2, slytherin: 1, ravenclaw: 0, hufflepuff: 3,
      },
      {
        optionText: 'Dragon heartstring', gryffindor: 3, slytherin: 2, ravenclaw: 1, hufflepuff: 0,
      },
      {
        optionText: 'Horned serpent horn', gryffindor: 0, slytherin: 3, ravenclaw: 2, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'Are you a pureblood?',
    answerOptions: [
      {
        optionText: 'Yes', gryffindor: 1, slytherin: 3, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'No', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 3,
      },
      {
        optionText: 'I don\'t know', gryffindor: 1, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
      {
        optionText: 'I don\'t care', gryffindor: 4, slytherin: 1, ravenclaw: 1, hufflepuff: 1,
      },
    ],
  },
  {
    questionText: 'Are you a potato?',
    answerOptions: [
      {
        optionText: 'Yes', gryffindor: 2, slytherin: 0, ravenclaw: 0, hufflepuff: 2,
      },
      {
        optionText: 'No', gryffindor: 1, slytherin: 2, ravenclaw: 2, hufflepuff: 0,
      },
      {
        optionText: 'I\'m a carrot', gryffindor: 1, slytherin: 0, ravenclaw: 1, hufflepuff: 4,
      },
      {
        optionText: 'Just show me where I belong', gryffindor: 1, slytherin: 4, ravenclaw: 2, hufflepuff: 0,
      },
    ],
  },
];
